import {MDCRipple} from '@material/ripple';

export function init(): void {
	document
		.querySelectorAll('.mdc-button')
		.forEach(el => new MDCRipple(el));
}
